import type { ChangeEvent, ReactNode } from 'react';

import { TextInput, UnstyledButton } from '@mantine/core';

import type { TextInputProps } from '@mantine/core';

import { CloseIconSm } from '@chownow/pantry/icons';

export interface InputTextProps extends TextInputProps {
  leftIcon?: ReactNode;
  onChange?: (event: ChangeEvent<HTMLInputElement> | string) => void;
  setValue?: (value: string) => void;
}

export default function InputText({
  leftIcon,
  onChange,
  setValue,
  rightSection,
  rightSectionPointerEvents,
  ...rest
}: InputTextProps) {
  const { value, disabled, id } = rest;

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = event.currentTarget.value;

    if (setValue) {
      setValue(newValue);
    } else if (onChange) {
      // needed for Mantine's form handler form.getInputProps
      onChange(event);
    }
  };

  const handleClear = () => {
    const clearedValue = '';

    if (setValue) {
      setValue(clearedValue);
    } else if (onChange) {
      onChange(clearedValue);
    }
  };

  const mergedRightSection = (
    <UnstyledButton
      aria-label="Clear input"
      onClick={handleClear}
      style={{
        display: value && !disabled ? 'flex' : 'none',
        alignItems: 'center',
        justifyContent: 'center',
        paddingInline: 'var(--mantine-spacing-xs)',
        height: '100%',
      }}
      data-testid={id ? `${id}ClearInput` : undefined}
    >
      <CloseIconSm />
    </UnstyledButton>
  );

  return (
    <TextInput
      {...rest}
      leftSection={leftIcon}
      onChange={handleChange}
      rightSectionPointerEvents={rightSectionPointerEvents ?? 'all'}
      rightSection={rightSection ?? mergedRightSection}
    />
  );
}
